/**
 * Checks if the coordinates (x, y) are inside the bounding rectangle of the given HTML element.
 *
 * @param {HTMLElement} element - The HTML element to check against.
 * @param {{ x: number; y: number }} coords - The coordinates to check.
 * @return {boolean} Whether the coordinates are inside the element's bounding rectangle.
 */
export const isClickInsideElement = (element: HTMLElement, coords: { x: number; y: number }): boolean => {
    const { x, y, width, height } = element.getBoundingClientRect();

    return x < coords.x && x + width > coords.x && y < coords.y && y + height > coords.y;
};
